import { FormlyFieldConfig } from '@ngx-formly/core';

import { ISnFormFieldGroupWrapperTemplateOptions } from './form-field-group-wrapper-template-options.interface';

export interface ISnFormFieldGroupWrapperConfig extends FormlyFieldConfig {
  wrappers: ['form-field-group'];
  fieldGroup: FormlyFieldConfig[];
  fieldGroupClassName?: string;
  templateOptions?: ISnFormFieldGroupWrapperTemplateOptions;
}
